import { Button, ButtonProps } from "@mui/material";
import { icon } from "../app/style/icons";

export default function ArrowButton({ children, ...props }: ButtonProps) {
    return (
        <Button variant={"contained"} endIcon={<icon.arrowRight sx={{ ml: 0.75, color: "semantic.button.text" }} />} {...props}>
            {children}
        </Button>
    );
}
